import { hoursStatusMap, shiftParticipantHoursHistoryStatus } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
export function usePastShiftsTableFilterConfig() {
    const { t } = useMissionsTranslation();
    return useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'search',
            dataTest: 'toolbar-quick-search-input',
            label: t('common.search'),
            sx: { maxWidth: { xs: undefined, sm: 343 } },
        });
        builder.quickFilterMultiSelect({
            label: t('adminPages.status'),
            widget: 'form.multiSelect',
            dataPath: 'status',
            values: shiftParticipantHoursHistoryStatus.map((participantStatus) => {
                return {
                    label: hoursStatusMap[participantStatus],
                    value: participantStatus,
                };
            }),
            sx: { maxWidth: { xs: undefined, sm: 280 } },
        });
        builder.quickDateRangeFilter({
            label: t('adminPages.dateRanges'),
            dataPath: 'dateRange',
            sx: { maxWidth: { xs: undefined, sm: 280 } },
        });
    }, [t]);
}
